import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  static get targets() { return ["trackingNumber"]; }

  submit(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.url;

    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    // The shipless form has no tracking input; an undefined value drops the key, which is the
    // body the shipless action was already being sent.
    options.body = JSON.stringify({
      gift: {
        tracking_number: this.hasTrackingNumberTarget ? this.trackingNumberTarget.value : undefined
      }
    });

    fetch(url, options).
      then(response => {
        if (!response.ok) { throw new Error(`Fulfillment update failed (${response.status})`); }
        return response.text();
      }).
      // The response is this row re-rendered, so the controller replaces its own element and
      // Stimulus reconnects the replacement. Server-rendered HTML from our own action, same-origin,
      // Rails-escaped: Suppliers::FulfillmentsController#set_tracking / #set_shipless, both
      // rendering the "fulfillment_row" partial (app/views/suppliers/fulfillments/_fulfillment_row.html.haml).
      then(html => { this.element.outerHTML = html; }).
      catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }
}
